import { entityApi } from '../../Entity/api/entityApi';

/** setupEntity SG wizard — Entity API lookups (SSIC, postal code) */
export const sgEntityLookupApi = {
  getSSICList: () => entityApi.getSSICList(),
  searchPostalCode: (postalCode: string) => entityApi.searchPostalCode(postalCode),
};
